import { useContext } from "react";
import TrackingContext from "./TrackingContext";
import { EventNames } from "./tracking.types";

/**
 * Custom hook to access tracking functionality from any component
 * @returns {Object} Tracking methods
 * @returns {Function} returns.trackEvent - Track an event
 * @returns {Function} returns.setUserProperties - Set user properties
 * @returns {Function} returns.resetUser - Reset user to anonymous
 * @returns {boolean} returns.isInitialized - Whether tracking is initialized
 * @returns {Object} returns.EventNames - Common event name constants
 */
export const useTracking = () => {
  const context = useContext(TrackingContext);

  if (!context) {
    console.error("useTracking must be used within a TrackingProvider");

    // Return no-op functions to prevent errors
    return {
      trackEvent: ({
        name,
        params,
      }: {
        name: string;
        params: Record<string, any>;
      }) => {},
      setUserProperties: () => {},
      resetUser: () => {},
      isInitialized: false,
      EventNames,
    };
  }

  // Add EventNames to the returned object for convenience
  return {
    ...context,
    EventNames,
  };
};

export default useTracking;
